<template>
  <b-modal
    id="contact-tag-modal"
    ref="contactTagModal"
    :title="`${update ? 'Update': 'Create New'} Tag`"
    hide-footer
    size="md"
    @hidden="clear">
    <label
      class="col-form-label pt-0">
      Name
    </label>
    <b-form-group>
      <b-input
        v-model="name"
        autofocus
        placeholder="Add Name"/>
      <span
        v-if="validationErrors.name"
        class="validation-error clearfix">
        {{ validationErrors.name }}
      </span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="saveTag">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'ContactTagModal',
  props: {
    tagp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      type: 'text',
      options: [],
      update: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      contactTagCreated: 'contact/contactTagCreated',
      contactTagUpdated: 'contact/contactTagUpdated',
      apiError: 'contact/apiError',
    }),
  },
  watch: {
    contactTagCreated(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', saved);
        this.hide();
      }
    },
    contactTagUpdated(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', saved);
        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      createContactTag: 'contact/createContactTag',
      updateContactTag: 'contact/updateContactTag',
    }),
    setTagData() {
      if (!this.$lodash.isEmpty(this.tagp)) {
        this.update = true;
        this.name = this.tagp.name;
      } else {
        this.clear();
      }
    },
    saveTag() {
      this.saving = true;
      const data = {
        name: this.name,
      };

      if (this.update) {
        this.updateContactTag({
          merchant_id: this.$route.params.merchant_id,
          tag_id: this.tagp.id,
          data,
        });
      } else {
        this.createContactTag({
          merchant_id: this.$route.params.merchant_id,
          data,
        });
      }
    },
    show() {
      this.setTagData();
      this.$refs.contactTagModal.show();
    },
    clear() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hide() {
      this.$refs.contactTagModal.hide();
    },
  },
};
</script>
